import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Status Badge Component
 * Displays status with appropriate color coding
 * Used in mes-dossiers.js, Devis.js, Factures.js
 */

// Status configurations for different contexts
export const DOSSIER_STATUS = {
  0: { label: 'Documents manquants', color: '#EF4444' },    // Red
  1: { label: 'Dossier soumis', color: '#EAB308' },         // Yellow
  2: { label: 'En cours d\'analyse', color: '#3B82F6' },    // Blue
  3: { label: 'Dossier soumis', color: '#EAB308' },         // Yellow
  4: { label: 'En cours d\'analyse', color: '#3B82F6' },    // Blue
  5: { label: 'Dossier validé', color: '#22C55E' },         // Green
  6: { label: 'Documents manquants', color: '#EF4444' },    // Red
};

export const QUOTE_STATUS = {
  save: { label: 'Enregistré', color: '#EAB308' },
  send: { label: 'Envoyé', color: '#22C55E' },
  pending: { label: 'En attente', color: '#3B82F6' },
  paid: { label: 'Payé', color: '#22C55E' },
};

export const INVOICE_STATUS = {
  save: { label: 'Enregistré', color: '#EAB308' },
  send: { label: 'Envoyé', color: '#22C55E' },
  pending: { label: 'En attente', color: '#3B82F6' },
  paid: { label: 'Payé', color: '#22C55E' },
};

export default function StatusBadge({ 
  status, 
  type = 'dossier',
  className = '',
  fullWidth = false,
}) {
  const statusConfig = type === 'dossier' 
    ? DOSSIER_STATUS 
    : type === 'quote' 
      ? QUOTE_STATUS 
      : INVOICE_STATUS;

  const config = statusConfig[status] || { label: status || '-', color: '#6B7280' };

  return (
    <span
      className={`inline-flex items-center justify-center px-3 py-1.5 rounded-md text-sm font-medium text-white ${className}`}
      style={{ 
        backgroundColor: config.color,
        width: fullWidth ? '100%' : 'auto',
      }}
    >
      {config.label}
    </span>
  );
}

StatusBadge.propTypes = {
  status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  type: PropTypes.oneOf(['dossier', 'quote', 'invoice']),
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};

/**
 * Get status label without rendering a badge
 */
export function getStatusLabel(status, type = 'dossier') {
  const statusConfig = type === 'dossier' 
    ? DOSSIER_STATUS 
    : type === 'quote' 
      ? QUOTE_STATUS 
      : INVOICE_STATUS;

  return statusConfig[status]?.label || status || '-';
}

/**
 * Get status color without rendering a badge
 */
export function getStatusColor(status, type = 'dossier') {
  const statusConfig = type === 'dossier' 
    ? DOSSIER_STATUS 
    : type === 'quote' 
      ? QUOTE_STATUS 
      : INVOICE_STATUS;

  return statusConfig[status]?.color || '#6B7280';
}
